import React, { useEffect, useState } from "react";
import ImgCarousel from "./ImgCarousel";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import ProductCard from "./ProductCard";

const OurProducts = () => {
  const [products, setProducts] = useState(null);
  const [carouselImg, setCarouselImg] = useState(null);
  const usersCollectionRef = collection(db, "products");

  const getProducts = async () => {
    const data = await getDocs(usersCollectionRef);
    setProducts(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })));
  };

  useEffect(() => {
    getProducts();
  }, []);

  return (
    <div className="py-20 w-full bg-gray-50">
      <h1 className="text-4xl font-bold text-gray-800 text-center">
        Our Products
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 mt-10 gap-6 w-[80%] mx-auto">
        {products &&
          products.map((product) => {
            return (
              <ProductCard product={product} setCarouselImg={setCarouselImg} />
            );
          })}

        {carouselImg && (
          <>
            <ImgCarousel
              carouselImg={carouselImg}
              setCarouselImg={setCarouselImg}
            />
            {/* <div className="fixed top-0 right-0 left-0 bottom-0 bg-[#34343499]"></div> */}
          </>
        )}
      </div>
    </div>
  );
};

export default OurProducts;
